import Vue from 'vue';
import Vuex from 'vuex';
import meterReadingManagement from './modules/meterReadingManagement';
import menu from './modules/menu';

Vue.use(Vuex);

export default new Vuex.Store({
    namespaced: true,
    state: {
        userInfo: [],//通过关键字查询得到业主信息
        userName: '',
        menulist: [], // 所有的子系统id和子系统名称组成的键值对数组
        sysMenuList: [],    // 系统对应的菜单
        billType: '',//账单类型
        waterPriceInfo: [],// 水司全部的用水类型信息
        showWaterTypeDialog: false,//是否显示用水类型细节弹框
        waterInfo: {},
        enprNo: '', // 当前水司的编码
        systemName: '', // 当前系统名称
        enterPriseList: [],  // 管理员业主下的水司列表,
        faultRegionData: {},                  // 异常水表小区查询数据
        searchByKeywords: [], // 水表抄读主界面查询结果
    },
    mutations: {
        // 通过changeUserInfo方法，改变state里面的userIofo。
        changeUserInfo (state, item) {
            return state.userInfo = item;
            // state.userInfo = basicInfo
        },
        getWaterPrinceInfo (state, arr) {
            return state.waterPriceInfo = arr;
        },
        // 改变showWaterTypeDialog的值
        changeShowWaterTypeDialog (state, userType) {
            for (let i = 0; i < state.waterPriceInfo.length; ++i) {
                if (userType == state.waterPriceInfo[i].type) {
                    state.waterInfo = state.waterPriceInfo[i]
                }
            }
            return state.showWaterTypeDialog = !state.showWaterTypeDialog;
        },
        // 获取所有的子系统id和子系统名称组成的键值对数组，设置 menuList
        setMenuList (state, arr) {
            return state.menulist = arr;
        },
        // 设置对应系统的菜单
        setSystemMenuList (state, arr) {
            return state.sysMenuList = arr;
        },
        // 设置当前水司编号
        setEnprNo (state, enprNo) {
            return state.enprNo = enprNo;
        },
        // 设置当前系统名称
        setSystemName (state, stName) {
            return state.systemName = stName;
        },
        setEnterPriseList (state, epList) {
            return state.enterPriseList = epList;
        },
        setFaultRegionData (state, msg) {
            return state.faultRegionData = msg;
        },
        setSearchByKeyword (state, msg) {
            return state.searchByKeywords = msg;
        }
    },
    actions: {},
    getters: {
        getEnterPriseList (state) {
            return state.enterpriseList;
        }
    },
    modules: {
        meterReadingManagement,
        menu,
    },

})



// WEBPACK FOOTER //
// ./src/store/index.js